import { render, staticRenderFns } from "./OtelJava.vue?vue&type=template&id=7be46c42&scoped=true"
import script from "./OtelJava.vue?vue&type=script&lang=js"
export * from "./OtelJava.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be46c42",
  null
  
)

export default component.exports